import serviceBase from '../../../../Services/serviceBase'

class NewsPreviewActions {
  getAll = async (fireDepartmentIdentifier, dateFrom = undefined) => {
    let url = `${window._env_.COMMUNITY_API_URL}/news-preview/${fireDepartmentIdentifier}`

    if (dateFrom) url = `${url}?dateFrom=${dateFrom}`
    
    try {
      const response = await serviceBase.get(url)
      return response?.data
    } catch (error) {
      return
    }
  }
}

export default new NewsPreviewActions()
